import { Collection } from '@nozbe/watermelondb';

import {
    HorseContactModel,
    HorseContactPayload,
} from '../../../../types/HorseContact';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareCreateHorseContact = ({
    payload,
    userId,
    organisationID,
    collection,
}: {
    payload: HorseContactPayload;
    userId: string;
    organisationID: string;
    collection: Collection<HorseContactModel>;
}) =>
    collection.prepareCreate((horseContact) => {
        horseContact.horseId = payload.horseId;
        horseContact.contactId = payload.contactId;
        horseContact.userId = userId;
        horseContact.organisationId = organisationID;
    });

export const logAddHorseContactAction = ({
    horseContact,
    logDBAction,
    tableName,
}: {
    horseContact: HorseContactModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Create horse contact',
        modelName: tableName,
        payload: horseContact,
    });
};
